import React from "react";
import { Link } from "react-router-dom";
import "./Hero.css";
import { TypeAnimation } from "react-type-animation"; // ✅ Import typing animation

const Hero = () => {
  return (
    <section className="hero" id="hero">
      <div className="hero-content">
        <h1>
          Hi, I'm <span className="highlight">Hananeh</span>
        </h1>

        <p className="subtitle">
          A passionate{" "}
          <TypeAnimation
            sequence={[
              "Graphic Designer", 2000,
              "UX/UI Designer", 2000,
              "Frontend Developer", 2000,
            ]}
            wrapper="span"
            speed={50}
            repeat={Infinity}
            className="typing-text"
          />
        </p>

        <div className="buttons">
          <a
            href={`${process.env.PUBLIC_URL}/Hananeh Mojadadi Resume.pdf.pdf`}
            target="_blank"
            rel="noopener noreferrer"
            className="btn primary"
          >
            View Resume
          </a>

          <Link to="/project-gallery" className="btn glass">
            View Project
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Hero;

